import { useState } from "react";
import ProjectTab from "components/Admin/ProjectTab";
import { useData } from "context/DataContext";
import Loader from "utils/Loader";
import LoginModal from "components/LoginModal";
import ProjectForm from "components/ProjectForm";
import Category from "components/Category";
import { useEffect } from "react";
import PlatformBids from "components/PlatformBids";
import Platform from "components/Platform";
import ClientLinks from "components/ClientLinks";
import NewDevs from "components/NewDevs";

// dashboard
const Dashboard = () => {
  // data context/DataContext
  const { data, user, categories } = useData();
  // active tab
  const [activeTab, setActiveTab] = useState(0);
  // categories list
  const tabList = [
    { name: "Bids", component: <PlatformBids  /> },
    { name: "Projects", component: <ProjectForm /> },
    { name: "Platform", component: <Platform  /> },
    { name: "Categories", component: <Category /> },
    { name: "Client Links", component: <ClientLinks /> },
    // { name: "New Devs", component: <NewDevs /> },
  ];

  if (user?.isAuth) {
    // if (!data?.loaded) {
    // return (
    //     <main className="page_wrapper">
    //         <div className="cs_container text_center">
    //             <Loader type="imgloader" />
    //         </div>
    //     </main>
    // )
    // }
    return (
      <main className="page_wrapper">
        <div className="cs_container">
          <div className="cs_row flex-wrap btns_row justify-content-center align-items-center">
            {tabList?.map((v, i) => (
              <button
                key={i}
                onClick={() => setActiveTab(i)}
                className={`cs_btn ${activeTab === i ? "active_cs_btn" : ""}`}
              >
                {v?.name}
              </button>
            ))}
          </div>
          {/* <ProjectForm /> */}
          {tabList[activeTab].component}
        </div>
      </main>
    );
  } else if (user.isLoading) {
    return (
      <main className="page_wrapper">
        <div className="cs_container text_center">
          <Loader type="imgloader" />
        </div>
      </main>
    );
  } else {
    return <LoginModal />;
  }
};

export default Dashboard;
